import { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const DropdownContainer = styled.div`
  position: relative;
  width: 200px;
  font-family: Arial, sans-serif;
`;

const DropdownButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    border-color: #999999;
  }
`;

const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  padding: 8px 0;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};
`;

const ListItem = styled.li`
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  background: ${(props) => (props.$isSelected ? '#f5f5f5' : 'transparent')};
  color: ${(props) => (props.$isSelected ? '#333333' : '#666666')};

  &:hover {
    background: #f5f5f5;
  }
`;

const Dropdown = ({ style, options, selectedOption, setSelectedOption }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <DropdownContainer style={style} ref={dropdownRef}>
      <DropdownButton onClick={() => setIsOpen(!isOpen)}>
        {selectedOption}
        <span>{isOpen ? '▲' : '▼'}</span>
      </DropdownButton>

      <DropdownList $isOpen={isOpen}>
        {options.map((option) => (
          <ListItem
            key={option}
            $isSelected={option === selectedOption}
            onClick={() => {
              setSelectedOption(option);
              setIsOpen(false);
            }}
          >
            {option}
          </ListItem>
        ))}
      </DropdownList>
    </DropdownContainer>
  );
};

export default Dropdown;
